<template>
  <div
    class='Fuell-Table--row'
    :style="tableGridTemplateStyle"
  >

    <div class='Fuell-Table--item'>

      <div class='flex'>
        <user-name-badge
          :userName='fullUserName'
          :userAvatarId='userProfilePictureId'
        >
        </user-name-badge>
        <span class='ellipsis dark'>
          {{ fullUserName }}
        </span>
      </div>
    </div>

    <div
      class='Fuell-Table--item'
      v-if="isColumnVisible('restaurants_status')"
      @click.stop
    >
      <div class='d-flex justify-content-center w-100'>
        <input-checkbox
          :id='`user-ret-${user.id}-meals`'
          :label="''"
          @change="handleConfirmFeatureDeactivation('FLEXIBLE_REMUNERATION_MEAL', 'RESTAURANTS')"
          updateOnChange
          :value.sync='foodFlexibleRemunerationStatus'
        ></input-checkbox>
      </div>
    </div>

    <div
      class='Fuell-Table--item'
      v-if="isColumnVisible('restaurants_current_assigned')"
    >
      <!-- ASSIGNED FOOD -->
      <money-input
        :id="'mealsLimitInput'"
        :value.sync='assignedFood'
        :disabled='!hasFoodFlexibleRemuneration '
        @change="handleRetFlexBudgetLimits('RESTAURANTS', assignedFood)"
        :allowNegative='false'
      ></money-input>
    </div>

    <div
      class='Fuell-Table--item'
      v-if="isColumnVisible('restaurants_next_month_assigned')"
    >
      <!-- MONTHLY ASSIGNED FOOD -->
      <money-input
        :id="'mealsMonthlyAssignedInput'"
        :value.sync='monthlyAssignedFood'
        :disabled='!hasFoodFlexibleRemuneration'
        @change="handleRetFlexBudgetLimits('RESTAURANTS', monthlyAssignedFood, false)"
        :allowNegative='false'
      ></money-input>
    </div>

    <!-- GAP COLUMN -->
    <!-- <div
      class="Fuell-Table--item"
      style="padding: 0"
    ></div> -->

    <div
      class="Fuell-Table--item"
      v-if="isColumnVisible('restaurants_spent_vs_available')"
    >
      <budget-progress-bar
        :spent='foodSpent'
        :assigned='foodAssigned'
        :budgetCardProgressTemplate='false'
        :goal='foodAssigned'
        :available='foodAvailable'
        :disabled='!hasFoodFlexibleRemuneration'
      ></budget-progress-bar>
    </div>

    <!-- GAP COLUMN -->
    <!-- <div
      class="Fuell-Table--item"
      style="padding: 0"
    ></div>
 -->
    <div
      class='Fuell-Table--Item'
      v-if="isColumnVisible('transport_status')"
    >
      <div class='d-flex justify-content-center w-100'>
        <input-checkbox
          :id='`user-ret-${user.id}-transports`'
          :label="''"
          @change="handleConfirmFeatureDeactivation('FLEXIBLE_REMUNERATION_TRANSPORT', 'TRANSPORT')"
          updateOnChange
          :checkboxClass="'Checkbox--red'"
          :value='transportFlexibleRemunerationStatus'
        ></input-checkbox>
      </div>
    </div>
    <div
      class='Fuell-Table--item'
      v-if="isColumnVisible('transport_current_assigned')"
    >
      <!-- ASSIGNED TRANSPORT -->
      <money-input
        :id="'transportLimitInput'"
        :value.sync='assignedTransport'
        :disabled='!hasTransportFlexibleRemuneration'
        :allowNegative='false'
        :color="'red'"
        @change="handleRetFlexBudgetLimits('TRANSPORT', assignedTransport)"
      >
      </money-input>
    </div>

    <div
      class='Fuell-Table--item'
      v-if="isColumnVisible('transport_next_month_assigned')"
    >
      <!-- MONTHLY ASSIGNED TRANSPORT -->
      <money-input
        :id="'mealsMonthlyAssignedInput'"
        :value.sync='monthlyAssignedTransport'
        :disabled='!hasTransportFlexibleRemuneration'
        @change="handleRetFlexBudgetLimits('TRANSPORT', monthlyAssignedTransport, false)"
        :allowNegative='false'
        :color="'red'"
      ></money-input>

    </div>

    <!-- GAP COLUMN -->
    <!-- <div
      class="Fuell-Table--item"
      style="padding: 0"
    ></div>
 -->
    <div
      class='Fuell-Table--item'
      v-if="isColumnVisible('transport_spent_vs_available')"
    >
      <budget-progress-bar
        :spent='transportSpent'
        :assigned='transportAssigned'
        :budgetCardProgressTemplate='false'
        :goal='transportAssigned'
        :available='transportAvailable'
        alternateColor
        :disabled='!hasTransportFlexibleRemuneration'
      ></budget-progress-bar>

    </div>

    <!-- GAP COLUMN -->
    <!-- <div
      class="Fuell-Table--item"
      style="padding: 0"
    ></div> -->

    <div
      class='Fuell-Table--Item'
      v-if="isColumnVisible('nursery_status')"
    >
      <div class='d-flex justify-content-center w-100'>
        <input-checkbox
          :id='`user-ret-${user.id}-nursery`'
          :label="''"
          @change="handleConfirmFeatureDeactivation('FLEXIBLE_REMUNERATION_NURSERY', 'NURSERY')"
          updateOnChange
          :checkboxClass="'Checkbox--orange'"
          :value='nurseryFlexibleRemunerationStatus'
        ></input-checkbox>
      </div>
    </div>

    <div
      class='Fuell-Table--item'
      v-if="isColumnVisible('nursery_current_assigned')"
    >

      <template v-if='!isImpersonating'>
        <span class="d-flex w-100 justify-content-center">

          {{ nurseryAssigned | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          }) }}</span>
      </template>
      <template v-else>
        <money-input
          :id="'nurseryLimitInput'"
          :value.sync='assignedNursery'
          :disabled='!hasNurseryFlexibleRemuneration '
          @change="handleRetFlexBudgetLimits('NURSERY',assignedNursery)"
          :allowNegative='false'
        ></money-input>

      </template>

    </div>
    <div
      class='Fuell-Table--Item'
      v-if="isColumnVisible('insurance_status')"
    >
      <div class='d-flex justify-content-center w-100'>
        <input-checkbox
          :id='`user-ret-${user.id}-insurance`'
          :label="''"
          @change="handleConfirmFeatureDeactivation('FLEXIBLE_REMUNERATION_INSURANCE', 'INSURANCE')"
          updateOnChange
          :checkboxClass="'Checkbox--purple'"
          :value='insuranceFlexibleRemunerationStatus'
        ></input-checkbox>
      </div>
    </div>
    <div
      class='Fuell-Table--item d-flex justify-content-around align-items-center'
      v-if="isColumnVisible('insurance_current_assigned')"
    >

      <template v-if='!isImpersonating'>
        <span class="w-50">
          {{ insuranceAssigned | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          }) }}</span>
      </template>
      <template v-else>
        <div
          class="w-100"
          @click="showPolicyHoldersWarning"
        >
          <money-input
            :id="'insuranceLimitInput'"
            :value.sync='assignedInsurance'
            :disabled="disableInsuranceAssignationInput"
            @click="showPolicyHoldersWarning"
            @change="handleRetFlexBudgetLimits('INSURANCE',assignedInsurance)"
            :allowNegative='false'
          ></money-input>
        </div>
      </template>

    </div>
    <div
      class='Fuell-Table--item d-flex justify-content-around align-items-center'
      v-if="isColumnVisible('insurance_policy_holder')"
    >

      <template v-if='!isImpersonating'>
        <span class="d-flex w-100 justify-content-center">
          {{ insurancePolicyHolders}}
        </span>
      </template>
      <template v-else>
        <money-input
          :id="'insurancePolicyHolderInput'"
          :value.sync='insurancePolicyHoldersValue'
          hideCurrency
          :precision="0"
          :disabled='!hasInsuranceFlexibleRemuneration '
          @change="setInsuranceHolders('regular')"
          :allowNegative='false'
        ></money-input>

      </template>

    </div>

    <div
      class='Fuell-Table--item d-flex justify-content-around align-items-center'
      v-if="isColumnVisible('insurance_disabled_policy_holders')"
    >
      <template v-if='!isImpersonating'>
        <span class="d-flex w-100 justify-content-center">
          {{insuranceDisabledPolicyHolders}}
        </span>
      </template>
      <template v-else>
        <money-input
          :id="'insuranceDisabledPolicyHolders'"
          :value.sync='insuranceDisabledPolicyHoldersValue'
          hideCurrency
          :precision="0"
          :disabled='!hasInsuranceFlexibleRemuneration '
          @change="setInsuranceHolders('disabled')"
          :allowNegative='false'
        ></money-input>
      </template>
    </div>

    <div
      class='Fuell-Table--Item'
      v-if="isColumnVisible('education_status')"
    >
      <div class='d-flex justify-content-center w-100'>
        <input-checkbox
          :id='`user-ret-${user.id}-education`'
          :label="''"
          @change="handleConfirmFeatureDeactivation('FLEXIBLE_REMUNERATION_EDUCATION', 'EDUCATION')"
          updateOnChange
          :checkboxClass="'Checkbox--green'"
          :value='educationFlexibleRemunerationStatus'
        ></input-checkbox>
      </div>
    </div>
    <div
      class='Fuell-Table--item'
      v-if="isColumnVisible('education_current_assigned')"
    >

      <template v-if='!isImpersonating'>
        <span class="d-flex w-100 justify-content-center">

          {{ educationAssigned | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          }) }}</span>
      </template>
      <template v-else>
        <money-input
          :id="'educationLimitInput'"
          :value.sync='assignedEducation'
          :disabled='!hasEducationFlexibleRemuneration '
          @change="handleRetFlexBudgetLimits('EDUCATION',assignedEducation)"
          :allowNegative='false'
        ></money-input>

      </template>

    </div>
  </div>
</template>

<script>
import MoneyInput from '@/components/Commons/Forms/MoneyInput'
import InputCheckbox from '@/components/Commons/Forms/InputCheckbox'
import UserNameBadge from '@/components/Commons/UserNameBadge'
import BudgetProgressBar from '@/modules/budgets/_components/_shared/BudgetProgressBar'
import _userRetFlexHandler from '../../_mixins/_userRetFlexHandler'
import _userBenefitsRowsCommons from '../../_mixins/_userBenefitsRowsCommons'
import _benefitsSharedMethods from '../../_mixins/_benefitsSharedMethods'

import { segmentTrack } from '@/analytics/segment'

export default {
  name: 'UsersFlexibleRetributionTableRow',
  props: {
    user: {
      type: Object
    },
    columns: {
      type: Array
    }
  },
  mixins: [_userRetFlexHandler, _userBenefitsRowsCommons, _benefitsSharedMethods],
  components: {
    UserNameBadge,
    InputCheckbox,
    BudgetProgressBar,
    MoneyInput
  },
  data () {
    return {
      foodFlexibleRemunerationStatus: false,
      transportFlexibleRemunerationStatus: false,
      assignedFood: 0,
      monthlyAssignedFood: 0,
      foodFlexibleRemunerationValue: false,
      transportFlexibleRemunerationValue: false,
      assignedTransport: 0,
      monthlyAssignedTransport: 0,
      budgetToUpdate: {},
      assignedNursery: 0,
      assignedEducation: 0,
      assignedInsurance: 0,
      insurancePolicyHoldersValue: 0,
      insuranceDisabledPolicyHoldersValue: 0,
      nurseryFlexibleRemunerationStatus: false,
      insuranceFlexibleRemunerationStatus: false,
      educationFlexibleRemunerationStatus: false
    }
  },
  computed: {
    foodMonthlyAssigned () {
      return this.foodFlexibleRemunerationBudget ? this.foodFlexibleRemunerationBudget.flexRemMonthlyAssigned : 0
    },
    transportMonthlyAsigned () {
      return this.transportFlexibleRemunerationBudget ? this.transportFlexibleRemunerationBudget.flexRemMonthlyAssigned : 0
    },
    nurseryAssigned () {
      return this.nurseryFlexibleRemunerationBudget ? this.nurseryFlexibleRemunerationBudget.flexRemAssigned : 0
    },
    foodStatus () {
      return this.user.mealFlexRemActivated
    },
    transportStatus () {
      return this.user.transportFlexRemActivated
    },

    nurseryStatus () {
      return this.user.nurseryFlexRemActivated
    },
    tableGridTemplateStyle () {
      return {
        gridTemplateColumns: this.columns.filter(c => this.isColumnVisible(c.key)).map(c => c.template).join(' '),
        gridGap: '15px'
      }
    },
    /* Formación */
    educationFlexibleRemunerationBudget () {
      return this.user && this.user.flexibleRemunerationUserBudgets.length > 0 ? this.user.flexibleRemunerationUserBudgets.find(el => el.activityGroup.code === 'EDUCATION') : false
    },
    educationAssigned () {
      return this.educationFlexibleRemunerationBudget ? this.educationFlexibleRemunerationBudget.flexRemAssigned : 0
    },
    educationStatus () {
      return this.user.educationFlexRemActivated
    },

    /* Seguros */
    insuranceAssigned () {
      return this.insuranceFlexibleRemunerationBudget ? this.insuranceFlexibleRemunerationBudget.flexRemAssigned : 0
    },
    insuranceStatus () {
      return this.user.insuranceFlexRemActivated
    },
    disableInsuranceAssignationInput () {
      if (!this.insuranceStatus) return true
      if (this.insurancePolicyHolders === 0 && this.insuranceDisabledPolicyHolders === 0) return true
      return false
    },
    hasAccumulativeBenefits () {
      if (this.officeConfig) {
        const hasAccumulativeBenefits = this.officeConfig.find(el => el.code === 'FLEXIBLE_REMUNERATION_CUMULATIVE')
        return hasAccumulativeBenefits ? hasAccumulativeBenefits.config.activated : false
      }
      return false
    }

  },
  methods: {
    _initialize () {
      this.foodFlexibleRemunerationStatus = this.foodStatus
      this.transportFlexibleRemunerationStatus = this.transportStatus
      this.assignedFood = this.foodAssigned
      this.monthlyAssignedFood = this.foodMonthlyAssigned
      this.monthlyAssignedTransport = this.transportMonthlyAsigned
      this.assignedTransport = this.transportAssigned
      this.foodFlexibleRemunerationValue = !!this.hasFoodFlexibleRemuneration
      this.transportFlexibleRemunerationValue = !!this.hasTransportFlexibleRemuneration
      this.assignedNursery = this.nurseryAssigned
      this.assignedEducation = this.educationAssigned
      this.assignedInsurance = this.insuranceAssigned
      this.nurseryFlexibleRemunerationStatus = this.nurseryStatus
      this.insuranceFlexibleRemunerationStatus = this.insuranceStatus
      this.educationFlexibleRemunerationStatus = this.educationStatus
      this.insurancePolicyHoldersValue = this.insurancePolicyHolders
      this.insuranceDisabledPolicyHoldersValue = this.insuranceDisabledPolicyHolders
    },
    async submitChange () {
      let updatedUser = {
        id: this.user.id,
        ...this.budgetToUpdate
      }

      await this.$store.dispatch('UsersStore/updateUser', updatedUser)
      segmentTrack('User benefit limit changed', {
        user_id: this.user.id,
        benefit: updatedUser.flexRetributionName,
        limit: this.assignedFood
      })
      this.budgetToUpdate = {}
    }
  },
  created () {
    this._initialize()
  },
  watch: {
    foodStatus: function (newV, oldV) {
      this.foodFlexibleRemunerationStatus = newV
    },
    foodAssigned: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.assignedFood = newV
      }
    },
    foodMonthlyAssigned: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.monthlyAssignedFood = newV
      }
    },
    transportStatus: function (newV, oldV) {
      this.transportFlexibleRemunerationStatus = newV
    },
    transportAssigned: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.assignedTransport = newV
      }
    },
    transportMonthlyAsigned: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.monthlyAssignedTransport = newV
      }
    },
    nurseryStatus: function (newV, oldV) {
      this.nurseryFlexibleRemunerationStatus = newV
    },
    nurseryAssigned: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.assignedNursery = newV
      }
    },
    educationStatus: function (newV, oldV) {
      this.educationFlexibleRemunerationStatus = newV
    },
    educationAssigned: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.assignedEducation = newV
      }
    },
    insuranceStatus: function (newV, oldV) {
      this.insuranceFlexibleRemunerationStatus = newV
    },

    insuranceAssigned: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.assignedInsurance = newV
      }
    },
    insurancePolicyHolders: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.insurancePolicyHoldersValue = newV
      }
    },
    insuranceDisabledPolicyHolders: function (newV, oldV) {
      if (newV !== oldV && newV >= 0) {
        this.insuranceDisabledPolicyHoldersValue = newV
      }
    }

  }

}
</script>

<style scoped>
.Fuell-Table--row,
.Fuell-Table--row:hover {
  width: fit-content;
}
.Fuell-Table--item {
  padding: 0px;
}

.Fuell-table--item >>> .assigned--red {
  background-color: var(--semantic-negative-main);
}

.Fuell-Table--item >>> .progress--assigned {
  background-color: var(--semantic-brand-main);
}
</style>
